/**
 * To define all tenant id's - Supports unlimited file upload minutes
 */
 export function IsUnlimitedFileUploadMinutesAvailableForTenant(tenantId: string | undefined): boolean {
  if (tenantId != null && typeof tenantId !== "undefined" && tenantId != '' && SupportedUnlimitedFileUploadMinutesTenantList.has(tenantId)) {
    return true;
  }

  return false;
}

 const SupportedUnlimitedFileUploadMinutesTenantList: Set<string> = new Set(
   // Please add new entry in the set to enable for new tenant
  ['72f988bf-86f1-41af-91ab-2d7cd011db47',
   '42b5e100-f4cf-49ee-bbdd-b5dccb93d02f', /* test account */
   'cdcb729d-5106-4d7c-b75b-a30c455d5b0a',
   '490a8197-7b83-4f10-89b9-83189be3835e',
   '1888e824-febb-4e67-b443-2f33261bc7e4',
   '388728e1-bbd0-4378-98dc-f8682e644300',
   '91377f48-86aa-448b-ae2e-54244a5a0143',
   '83ad3fca-a2e8-48e2-a356-9c6fcef6394f',
   '0f21eeac-90b4-459d-8106-867d93de9584',
   'b024cacf-dede-4241-a15c-3c97d553e9f3',
   '7b1dae53-b0bf-4338-a429-db7e024383c2',
   '2290d4cb-5767-4d49-aa6a-6cf982b837f6',
   '97548954-fd5c-4411-b07c-4dc445759c9a',
   '568f20ec-b2cb-4c6e-a73f-909f261dc7ae',
   '0988fb0f-dcf1-4419-8058-7f5b6b66ded7',
   'a44193d6-4fb5-453c-b231-6e9ab7c7c8da',
   '7ca7eb7e-b5cb-47bb-aea5-a64907214952',
   '0e7207fe-862e-483e-842f-c88d28fe5b6a',
   'b84ee435-4816-49d2-8d92-e740dbda4064',
   '37a1c317-7648-49a6-a1d0-69ae54f64188',
   '1a407a2d-7675-4d17-8692-b3ac285306e4',
   '5659e46e-3546-49a3-85d2-34f9a352034c',
   'b29fb4c0-0d04-4a9f-b462-c1294b1e1b47',
   'b23255a1-8f78-4144-8904-31f019036ade',
   'f0c59300-858e-4dd3-aa19-d3029ec23ac1',
   '0e2ed455-96af-4100-bed3-a8e5fd981685',
   'a4dd5294-24e4-4102-8420-cb86d0baae1e',
   'dfcc033d-df87-4c6e-a1b8-8eaa73f1b72e',
   '2ccd7aae-4761-400c-9cb8-00aeed7aba58',
   'dfc37891-55b9-4fe0-bc8b-34a0f4b6650f',
   'cd319671-52e7-4a68-afa9-fcf8f89f09ea',
   '39683655-1d97-4b22-be8c-246da0f47a41',
   '5a9cd8bc-d0c8-4fe2-80b8-e847ab635c62'
  ]
);